import { httpRequest } from "core/api/httpRequest";

/**
 * Get data required for a dropdown based on the url
 * @param url
 * @param requestType
 * @param requestBody
 * @returns
 */
export const getFormData = (
  url: any,
  requestType = "get",
  requestBody?: any,
) => {
  return httpRequest(url, requestType, requestBody);
};
